const { Message, Source, Role } = require('./Types')

function MessageReader({ messageMapping, otherWindow }) {
  return (event) => {
    if (event.source !== otherWindow || !event.data || event.data.source !== Source.ContentEdition) return

    const message = event.data
    if (!Object.prototype.hasOwnProperty.call(messageMapping, message.messageType)) return
    const action = messageMapping[message.messageType]
    if (typeof action !== 'function' || !message.data || typeof message.data !== 'object' || Array.isArray(message.data)) return
    action({ data: message.data })
  }
}

class Interface {
  static build(role, childWindow) {
    const otherWindow = (role === Role.Page) ? window.parent : childWindow

    return new Interface({ otherWindow, myWindow: window, myRole: role })
  }

  constructor({ otherWindow, myWindow, myRole }) {
    this.otherWindow = otherWindow
    this.myWindow = myWindow
    this.myRole = myRole
  }

  send({ messageType, data }) {
    const message = new Message({ role: this.myRole, messageType, data })
    this.otherWindow.postMessage(message, '*')
  }

  subscribeToMessages({ messageMapping }) {
    const messageReader = MessageReader({ messageMapping, otherWindow: this.otherWindow })
    this.myWindow.addEventListener('message', messageReader, false)
    return () => this.myWindow.removeEventListener('message', messageReader, false)
  }
}

module.exports = Interface
